export default "__VITE_ASSET__f5451efb__"